import { useEffect } from "react";

/** "Home · Fellowship". Screen readers announce the new title on navigation. */
export function useTitle(title: string) {
  useEffect(() => {
    document.title = title ? `${title} · Fellowship` : "Fellowship · Bible Standard";
  }, [title]);
}
